export default __webpack_public_path__ + "static/media/nft4.48b92939.png";